<template>
  <div id="userLayout">
    <div class="vb">
      <route-view></route-view>
    </div>
  </div>
</template>

<script>
  import RouteView from './RouteView'
export default {
  components:{
    RouteView
  },
  data () {
    return {

    }
  },

  mounted () {
  },

  methods: {

  }

}
</script>
<style>

.custom-placeholder   input ::-moz-placeholder {
  font-size: 12px;
  color: #999;
}
.custom-placeholder   input :-ms-input-placeholder {
  font-size: 12px;
  color: #999;
}
.custom-placeholder   input :-moz-placeholder {
  font-size: 12px;
  color: #999;
}

.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0,0,0,0);
  transform: rotate3d(0,0,0,0);
  -webkit-transition:
      background-color 100ms ease-out,
      margin 100ms ease-out,
      height 100ms ease-out;
  transition:
      background-color 100ms ease-out,
      margin 100ms ease-out,
      height 100ms ease-out;
  background-color: rgba(204, 204, 204,.5);
  margin: 5px 5px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgb(204, 204, 204);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgb(204, 204, 204);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgb(204, 204, 204);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgb(204, 204, 204);
}


.no_show_dragger  .vb-dragger {
  display: none !important;
}
</style>
